import {
  getMySurveyResponses as getMySurveyResponsesForSubject,
  submitSurveyResponse,
} from './subjectSurveyRequests';
import {
  getCurrentSurveyByGroup,
  getMySurveyResponses,
  getPublicSurveyByGroup,
  submitPublicSurveyResponse,
} from './surveyRequests';
import type { SurveysGateway } from '../ports/surveysGateway';

/**
 * Surveys' backend, over the generated API client.
 *
 * Each wire record is a superset of its domain type, so it passes through
 * whole rather than being copied field by field: every query key keeps the
 * shape it cached before the gateway existed, which code still reading those
 * keys directly depends on.
 */
export const fetchSurveysGateway: SurveysGateway = {
  getCurrentSurvey: (groupIdOrSlug) => getCurrentSurveyByGroup(groupIdOrSlug),

  getPublicSurvey: (groupIdOrSlug) => getPublicSurveyByGroup(groupIdOrSlug),

  listMyResponses: (subject) =>
    subject
      ? getMySurveyResponsesForSubject({ subjectType: subject.type, subjectId: subject.id })
      : getMySurveyResponses(),

  async submitResponse({ surveyDefinitionId, answers, subject }) {
    await submitSurveyResponse({ surveyDefinitionId, answers, subject });
  },

  submitPublicResponse: (surveyId, guest, answers) =>
    submitPublicSurveyResponse(surveyId, guest, answers),
};
